import Alpine from "alpinejs";
import collapse from '@alpinejs/collapse'
import resize from '@alpinejs/resize'
import focus from '@alpinejs/focus'
import {CountUp} from "countup.js";
import EmblaCarousel from 'embla-carousel';
import Fade from 'embla-carousel-fade';

// Embla Carousel.
window.EmblaCarousel = EmblaCarousel;
window.Fade = Fade;

// Alpine.js
window.Alpine = Alpine;
Alpine.plugin(collapse)
Alpine.plugin(resize)
Alpine.plugin(focus)
Alpine.start();

jQuery(document).ready(function ($) {
    var ajax_is_in_progress;
    var current_page = 1;
    // Accessibility menu
    $('.parent-menu').on('keydown', function (event) {

        if (event.code === 'Space') {
            event.preventDefault();
            // close open menus
            $('.sub-menu').each(function(index, element) {
                $(this).addClass('invisible scale-0');
            });

            var elm = $(this).closest('.dropdown-menu').find('.sub-menu');
            elm.toggleClass('invisible scale-0');

        }
    });

    // close menu on escape key
    $("body").keyup(function(event) {
        if (event.code === 'Escape') {
            $('.sub-menu').each(function(index, element) {
                $(this).addClass('invisible scale-0');
            });
        }
    });

    // Infinite scroll on Portfolios
    if ($('#portfolios').length > 0) {
        $(window).scroll(function () {
            const queryString = window.location.search;
            if ($(window).scrollTop() + $(window).height() > $(document).height() - 300) { // Adjust 100 to your preference
                if (!ajax_is_in_progress) { // You need a global var to prevent several requests at the same time
                    ajax_is_in_progress = true;
                    loadMorePosts(queryString);
                }
            }
        });
    }

    function loadMorePosts(queryString) {

        var your_query_vars = {
            'Are we passing vars': 'No, not really',
        };
        $.ajax({
            url : '/wp-admin/admin-ajax.php',
            data : {
                'action': 'loadmore',
                'query': your_query_vars,
                'page' : current_page,
                'filters' : queryString,
            },
            type : 'POST',
            success : function( data ){

                if( data ) {
                    var newContent = $(data.data).hide().fadeIn(1000);
                    $('#portfolios').append(newContent); // append new posts to container

                    current_page++;
                    ajax_is_in_progress = false; // Let AJAX be triggered again
                }
            }
        });
    }
    // End infinite scroll

    // Infinite scroll on Video listing
    if ($('#video-listing-section').length > 0) {
        $(window).scroll(function () {
            const queryString = window.location.search;
            if ($(window).scrollTop() + $(window).height() > $(document).height() - 300) { // Adjust 100 to your preference
                if (!ajax_is_in_progress) { // You need a global var to prevent several requests at the same time
                    ajax_is_in_progress = true;
                    loadMoreVideo(queryString);
                }
            }
        });
    }

    function loadMoreVideo(queryString) {

        var your_query_vars = {
            'Are we passing vars': 'No, not really',
        };
        $.ajax({
            url : '/wp-admin/admin-ajax.php',
            data : {
                'action': 'loadvideo',
                'query': your_query_vars,
                'page' : current_page,
                'filters' : queryString,
            },
            type : 'POST',
            success : function( data ){
                if( data ) {
                    var newContent = $(data.data).hide().fadeIn(1000);
                    $('#video-listing-section').append(newContent); // append new posts to container

                    current_page++;
                    ajax_is_in_progress = false; // Let AJAX be triggered again
                }
            }
        });
    }
    // End infinite scroll

    // Video pause button
    const player = $("#video-background").get(0);
    const pauseButton = $("#pause-btn");
    const playButton = $("#play-btn");
    $("#video-play").click(function () {
        if (player.paused) {
            player.play();
            pauseButton.show();
            playButton.hide();
        } else {
            player.pause();
            pauseButton.hide();
            playButton.show();
        }
    });

    if ($('#wp-admin-bar-new-post').length > 0) {
        $('#wp-admin-bar-new-post').hide();
    }

    // Swiper pagination fix
    if ($('.image-container').length > 0) {
        setPaginationTop();
    }
    $(window).on('resize', function() {
        if ($('.image-container').length > 0) {
            setPaginationTop();
        }
    });

    function setPaginationTop() {
        var image_height;
        $('.image-container').each(function(index, element) {
            image_height = $(this).height();
            //console.log(image_height);
        });
        if (image_height <380) image_height = 385;

        var pagination_top = image_height - 65;
        $('#swiper-pagination').css('top', pagination_top + 'px');
    }

    // hack to make carousel work with 3 images
    // if ($('.custom-swiper-button-prev').length > 0) {
    //     $('.custom-swiper-button-prev').trigger("click");
    // }
});



// Statistics block
const countupElements = document.querySelectorAll('.countup-number');

countupElements.forEach(element => {
    const endVal = parseFloat(element.textContent);
    const options = {
        duration: 2, // Example duration
        enableScrollSpy: true, // Example: start animation when element is in view
        scrollSpyOnce: false, // Example: only animate once
        useGrouping: true,
        separator: ','
    };

    // Only set decimalPlaces if the element has a decimal point
    if (element.textContent.includes('.')) {
        options.decimalPlaces = 2;
        options.decimal = '.';
    }

    const countUp = new CountUp(element, endVal, options);

    if (!countUp.error) {
        // If using enableScrollSpy, you don't need to call start() manually here
        // countUp.start();
    } else {
        console.error(countUp.error);
    }
});
// Resource filters
const categorySelect = document.querySelector('select#category');

if (categorySelect !== null) {
    categorySelect.addEventListener('change', (e) => {
        const selectedCategory = e.target.value;
        window.location.href = '/resources?category='+selectedCategory;
    });
}

document.addEventListener("DOMContentLoaded", function(){
    const FORM_TIME_START = Math.floor((new Date).getTime()/1000);
    let formElement = document.getElementById("tfa_0");
    let appendJsTimerElement = function(){
        let formTimeDiff = Math.floor((new Date).getTime()/1000) - FORM_TIME_START;
        let cumulatedTimeElement = document.getElementById("tfa_dbCumulatedTime");
        if (null !== cumulatedTimeElement) {
            let cumulatedTime = parseInt(cumulatedTimeElement.value);
            if (null !== cumulatedTime && cumulatedTime > 0) {
                formTimeDiff += cumulatedTime;
            }
        }
        let jsTimeInput = document.createElement("input");
        jsTimeInput.setAttribute("type", "hidden");
        jsTimeInput.setAttribute("value", formTimeDiff.toString());
        jsTimeInput.setAttribute("name", "tfa_dbElapsedJsTime");
        jsTimeInput.setAttribute("id", "tfa_dbElapsedJsTime");
        jsTimeInput.setAttribute("autocomplete", "off");
        if (null !== formElement) {
            formElement.appendChild(jsTimeInput);
        }
    };
    if (null !== formElement) {
        if(formElement.addEventListener){
            formElement.addEventListener('submit', appendJsTimerElement, false);
        } else if(formElement.attachEvent){
            formElement.attachEvent('onsubmit', appendJsTimerElement);
        }
    }
});

// home page vimeo controls
// Ensure the DOM is fully loaded before running the script
document.addEventListener('DOMContentLoaded', (event) => {
    // 1. Get the iframe element by its ID
    var iframe = document.getElementById('vimeoVideo');

    // 2. Initialize the Vimeo Player object using the SDK
    var player = new Vimeo.Player(iframe);
    var pause_btn = document.getElementById('pause-btn');
    var play_btn = document.getElementById('play-btn');
    var spinner = document.getElementById('spinner');

    // 3. Get your custom button element
    var playPauseButton = document.getElementById('video-play');

    // 4. Add a click event listener to the button
    playPauseButton.addEventListener('click', function() {
        // Check the current state of the video
        player.getPaused().then(function(paused) {
            if (paused) {
                // If paused, play the video and update the button text
                player.play();
                pause_btn.style.display = 'block';
                play_btn.style.display = 'none';
            } else {
                // If playing, pause the video and update the button text
                player.pause();
                pause_btn.style.display = 'none';
                play_btn.style.display = 'block';
            }
        }).catch(function(error) {
            // Handle any potential errors (e.g., privacy issues, password protected)
            console.error('Error checking video state:', error);
        });
    });

    player.on('waiting', function() {
        spinner.style.display = 'block';
    });

// Hide spinner when the video is ready to play or playing
    player.on('canplay', function() {
        spinner.style.display = 'none';
    });

    player.on('playing', function() {
        spinner.style.display = 'none';
    });
});

// play video on hover in listing page
document.addEventListener('DOMContentLoaded', (event) => {
    const iframes = document.getElementsByClassName("listing-video");
    if (iframes.length > 0) {
        for (let i = 0; i < iframes.length; i++) {
            const iframe = iframes[i];
            const player = new Vimeo.Player(iframe);

            iframe.addEventListener('mouseover', function() {
                player.play();
            });

            iframe.addEventListener('mouseout', function() {
                player.pause();
            });
        }
    }

});
